/**
 * Centralized URL configuration
 * All external service URLs should be defined here
 */

const isProd: boolean = process.env.REACT_APP_ENVIRONMENT === 'master';

// API URLs
export const API_BASE_URL: string = isProd
  ? 'https://api.mrbl.bio'
  : 'https://api-dev.mrbl.bio';

// Image Service URLs
export const IMAGE_SERVICE_URL: string = isProd
  ? 'https://image.mrbl.bio'
  : 'https://image-dev.mrbl.bio';

export const IMAGE_UPLOAD_URL: string = `${IMAGE_SERVICE_URL}/upload`;
export const IMAGE_UPLOAD_AVATAR_URL: string = `${IMAGE_SERVICE_URL}/upload_user_avatar`;
export const IMAGE_UPLOAD_DOCUMENT_URL: string = `${IMAGE_SERVICE_URL}/upload_document`;
export const IMAGE_PROXY_URL: string = `${IMAGE_SERVICE_URL}/proxy`;

// Geo Service URL
export const GEO_SERVICE_URL = 'https://geo.mrbl.bio' as const;

// Static Assets URL
export const STATIC_ASSETS_URL = 'https://static.mrbl.bio' as const;

// Marketing/Landing Page URL
export const MARKETING_URL = 'https://www.getmrbl.ai' as const;

// Origin URLs (for sharing/links)
export const ORIGIN_URL: string = isProd
  ? 'https://mrbl.bio'
  : 'https://dev.mrbl.bio';

// TikTok oEmbed URL
export const TIKTOK_OEMBED_URL = 'https://www.tiktok.com/oembed' as const;

/**
 * URL configuration object containing all service URLs
 */
interface UrlConfig {
  readonly API_BASE_URL: string;
  readonly IMAGE_SERVICE_URL: string;
  readonly IMAGE_UPLOAD_URL: string;
  readonly IMAGE_UPLOAD_AVATAR_URL: string;
  readonly IMAGE_UPLOAD_DOCUMENT_URL: string;
  readonly IMAGE_PROXY_URL: string;
  readonly GEO_SERVICE_URL: string;
  readonly STATIC_ASSETS_URL: string;
  readonly MARKETING_URL: string;
  readonly ORIGIN_URL: string;
  readonly TIKTOK_OEMBED_URL: string;
}

const urlConfig: UrlConfig = {
  API_BASE_URL,
  IMAGE_SERVICE_URL,
  IMAGE_UPLOAD_URL,
  IMAGE_UPLOAD_AVATAR_URL,
  IMAGE_UPLOAD_DOCUMENT_URL,
  IMAGE_PROXY_URL,
  GEO_SERVICE_URL,
  STATIC_ASSETS_URL,
  MARKETING_URL,
  ORIGIN_URL,
  TIKTOK_OEMBED_URL,
} as const;

export default urlConfig;
